import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard, CalendarCheck, Home, DollarSign, Users, Globe, Settings
} from 'lucide-react';

export type ConditionalKey = 'coParenting' | 'elderCare' | 'municipal';

export interface NavCategoryItem {
  id: string;
  label: string;
  path: string;
  conditional?: ConditionalKey;
}

export interface NavCategory {
  id: string;
  label: string;
  icon: LucideIcon;
  directPath?: string;   // if set → clicking this rail item navigates directly, no flyout
  items: NavCategoryItem[];
}

export const NAV_CATEGORIES: NavCategory[] = [
  {
    id: 'home',
    label: 'Home',
    icon: LayoutDashboard,
    directPath: '/dashboard',
    items: [],
  },
  {
    id: 'life',
    label: 'Life',
    icon: CalendarCheck,
    items: [
      { id: 'tasks',        label: 'Tasks',        path: '/tasks' },
      { id: 'calendar',     label: 'Calendar',     path: '/calendar' },
      { id: 'health',       label: 'Health',       path: '/health' },
      { id: 'meal-planner', label: 'Meal Planner', path: '/meal-planner' },
    ],
  },
  {
    id: 'household',
    label: 'Household',
    icon: Home,
    items: [
      { id: 'inventory',   label: 'Inventory',     path: '/groceries' },
      { id: 'maintenance', label: 'Maintenance',   path: '/maintenance' },
      { id: 'appliances',  label: 'Appliances',     path: '/appliances' },
      { id: 'documents',   label: 'Document Vault',path: '/documents' },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: DollarSign,
    items: [
      { id: 'finance',   label: 'Finance',   path: '/finance' },
      { id: 'analytics', label: 'Analytics', path: '/analytics' },
    ],
  },
  {
    id: 'people',
    label: 'People',
    icon: Users,
    items: [
      { id: 'contacts',  label: 'Contacts',     path: '/contacts' },
      { id: 'pets',      label: 'Pet Care',     path: '/pets' },
      { id: 'vehicles',  label: 'Vehicles',     path: '/vehicles' },
      { id: 'assistant', label: 'AI Assistant', path: '/assistant' },
    ],
  },
  {
    id: 'connected',
    label: 'Connected',
    icon: Globe,
    items: [
      { id: 'family-location',      label: 'Family Location',   path: '/family-location' },
      { id: 'co-parenting',        label: 'Co-Parenting',      path: '/co-parenting',        conditional: 'coParenting' },
      { id: 'elder-care',          label: 'Elder Care',        path: '/elder-care',          conditional: 'elderCare' },
      { id: 'municipal-services',  label: 'Municipal Services',path: '/municipal-services',  conditional: 'municipal' },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: Settings,
    items: [
      { id: 'settings',   label: 'Household Settings', path: '/settings' },
      { id: 'explore',    label: 'Explore',            path: '/explore' },
      { id: 'influencer', label: 'Refer a Friend',     path: '/influencer' },
      { id: 'feedback',   label: 'Feedback',           path: '/feedback' },
      { id: 'changelog',  label: 'Changelog',          path: '/changelog' },
    ],
  },
];
